import React from "react";
import { useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import { ColumnContainer } from "../../utils/columnsStyle";
import { dispenserUserSelected } from "../../redux/actions/dispenserUser/dispenserUserAction";

const style = {
  color: '#004F9F',
  fontSize: 20,
  marginRight: 10,
  cursor: 'pointer'
};

const configTable = [
  {
    Header: "Dispenser",
    accessor: "name",
    filterable: true,
    filterMethod: (filter, row) => row.name?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Driver User",
    accessor: d => d?.driverUser?.username || '', 
    id: 'driverUserName',
    filterable: true,
    filterMethod: (filter, row) => row[filter.id]?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Dispenser User",
    accessor: d => d?.dispenserUser?.username || '',
    id: 'dispenserUserName', 
    filterable: true,
    filterMethod: (filter, row) => row[filter.id]?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "IMEI",
    accessor: d => d?.dispenserUser?.imei || '', 
    id: "dispenserUserImei",
    filterable: true,
    filterMethod: (filter, row) => row[filter.id]?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Acciones",
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const openEdit = () => {
        original.modal(true);
        dispatch(dispenserUserSelected(original.id));
      };

      return (
        <ColumnContainer>
          {
            !original?.dispenserUser?.id && <EditIcon style={style} onClick={openEdit} />
          }
        </ColumnContainer>
      )
    },
  },
];

export { configTable };
